import { useAppTranslation } from "@/utils";
import type { GetChequeInfoResponse } from "@payping/api/app/api/bnplConsumerTypes";
import { CheckCircleFilled } from "@payping/icons";
import { URLS } from "@payping/utilities-shared/consts";
import { buildUrl } from "@payping/utilities-shared/url";
import { Button, Card, Divider, Flex, Typography } from "@payping/web-components";

interface FailedProps {
  afterSuccess: () => void;
  data: GetChequeInfoResponse;
}
const PayGetOrderChequeInquirySuccess = ({ afterSuccess, data }: FailedProps) => {
  const { t } = useAppTranslation();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4! tw:pt-8!" gap={"large"}>
      <Flex className="tw:w-full tw:p-3!" vertical gap={32} align="center">
        <Typography.Title level={5} className="tw:m-0!">
          {t("pay.getOrder.steps.chequeInquiry.success.title")}
        </Typography.Title>
        <Flex className="tw:w-full" justify="center" align="center" gap={4}>
          <Flex vertical gap={"middle"} justify="center" align="center">
            <Flex className="tw:h-14 tw:w-14 tw:rounded-full tw:bg-color-bg-layout" align="center" justify="center">
              <img
                src={buildUrl(URLS.STORAGE_URL, "bnpl-consumer/box-with-location.png").toString()}
                className="tw:h-auto tw:w-10 tw:object-contain"
              />
            </Flex>
            <Typography.Text type="secondary">
              {t("pay.getOrder.steps.chequeInquiry.success.sendCheque")}
            </Typography.Text>
          </Flex>
          <svg width="72" height="4" viewBox="0 0 70 4" fill="none" className="tw:mb-6! tw:stroke-color-border">
            <line x1={0} y1={0} x2={70} y2={0} strokeWidth={4} strokeDasharray="3 3" />
          </svg>
          <Flex vertical gap={"middle"} justify="center" align="center">
            <CheckCircleFilled width={56} className="tw:fill-color-success" />
            <Typography.Text type="success">
              {t("pay.getOrder.steps.chequeInquiry.success.submitCheque")}
            </Typography.Text>
          </Flex>
        </Flex>
        <Typography.Text className="tw:text-center">
          {t("pay.getOrder.steps.chequeInquiry.success.content")}
        </Typography.Text>
      </Flex>
      <Flex gap={"middle"} vertical>
        <Typography.Text>
          <strong>{t("pay.getOrder.steps.chequeInquiry.success.form.title")}</strong>
        </Typography.Text>
        <Card size="small">
          <Flex vertical className="tw:w-full" gap={"middle"}>
            <Flex vertical gap={4}>
              <Typography.Text type="secondary">
                {t("pay.getOrder.steps.chequeInquiry.success.form.agentName")}
              </Typography.Text>
              <Typography.Text>{data.agentName ?? ""}</Typography.Text>
            </Flex>
            <Divider className="tw:m-0!" />
            <Flex vertical gap={4}>
              <Typography.Text type="secondary">
                {t("pay.getOrder.steps.chequeInquiry.success.form.agentPhoneNumber")}
              </Typography.Text>
              <Typography.Text>{data.agentMobileNumber ?? ""}</Typography.Text>
            </Flex>
            <Divider className="tw:m-0!" />
            <Flex vertical gap={4}>
              <Typography.Text type="secondary">
                {t("pay.getOrder.steps.chequeInquiry.success.form.agentPostalCode")}
              </Typography.Text>
              <Typography.Text>{data.postalCode ?? ""}</Typography.Text>
            </Flex>
            <Divider className="tw:m-0!" />
            <Flex vertical gap={4}>
              <Typography.Text type="secondary">
                {t("pay.getOrder.steps.chequeInquiry.success.form.agentAddress")}
              </Typography.Text>
              <Typography.Text>{data.address ?? ""}</Typography.Text>
            </Flex>
          </Flex>
        </Card>
        <Card size="small" className="tw:border tw:border-solid tw:border-color-border-secondary tw:bg-color-bg-layout">
          {t("pay.getOrder.steps.chequeInquiry.success.warning")}
        </Card>
      </Flex>
      <Button block className="tw:mt-auto" type="primary" onClick={afterSuccess}>
        {t("common.confirmAndContinue")}
      </Button>
    </Flex>
  );
};

export default PayGetOrderChequeInquirySuccess;
